export default "__VITE_ASSET__qqvRW2kP__"